import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Props, WidgetFormProps, WidgetSliderInstance } from "./types";
import {
    TextField, Button, CardContent, CardHeader, FormControl,InputLabel, Select, MenuItem, FormControlLabel, Switch,
    Typography, Slider
} from '@material-ui/core';
import { WidgetInstance, WidgetKeys, SliderWidgetKeys } from 'mobx-store/stores/customScreens/types';
import styles from './styles.module.scss';
import VerticalWidgetCard from '../verticalWidgetCard';
import ClubOccupancyWidgetCard from '../clubOccupancyWidgetCard';
import GeneralWidgetCard from '../generalWidgetCard';
import HorizontalWidgetCard from '../horizontalWidgetCard';
import IconWidgetCard from '../iconWidgetCard';
import ThumbnailWidgetCard from '../thumbnailWidgetCard';
import ImageWidgetCard from '../imageWidgetCard';
import DangerIconButton from 'components/DangerIconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import KeyboardArrowLeftSharp from '@material-ui/icons/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharp from '@material-ui/icons/KeyboardArrowRightSharp';

import { NavigationOptions } from 'screens/addEditCustomScreen/components/navigationOptions';
import { useLocation } from 'react-router';
import {
  stores,
} from 'mobx-store';
import { getFormErrorState } from '../validation.helper';

//     WidgetKeys, WidgetInstance, CustomScreen,
//   } from '../../../mobx-store/stores/customScreens/types';

const GetWidgetForm: React.FC<WidgetFormProps> = (props: WidgetFormProps) => {
  const {
    focusedWidget,
    widgets
  } = props;
    const handleChange = (key: string, value: string) => {
      const currentWidget = widgets.findIndex((widget) => widget.widgetInstanceId.toString() === focusedWidget?.toString());
      if (currentWidget !== -1) {
        const widgetsCopy = widgets.slice(0);
        widgetsCopy[currentWidget] = {
          ...widgets[currentWidget],
          params: {
            ...widgets[currentWidget].params,
            [key]: value,
          },
        };
        console.log('widgetsCopy[current', widgetsCopy[currentWidget].widgetKey ,' - ' , widgetsCopy[currentWidget].params)
        props.setErrorState(
          getFormErrorState(
            widgetsCopy[currentWidget].widgetKey,
            widgetsCopy[currentWidget].params
          )
        );
        props.setWidgets(widgetsCopy);
      }
    };
    const handleMultipleChange = (params: {}) => {
      const currentWidget = widgets.findIndex((widget) => widget.widgetInstanceId.toString() === focusedWidget?.toString());
      if(currentWidget === -1) { return; }
      const widgetsCopy = widgets.slice(0);
      widgetsCopy[currentWidget] = {
        ...widgets[currentWidget],
        params: {
          ...widgets[currentWidget].params,
          ...params
        },
      };
      console.log('widgetsCopy[current', widgetsCopy[currentWidget].widgetKey ,' - ' , widgetsCopy[currentWidget].params)
      props.setErrorState(
        getFormErrorState(
          widgetsCopy[currentWidget].widgetKey,
          widgetsCopy[currentWidget].params
        )
      );
      props.setWidgets(widgetsCopy);
    };

    const removeFocusedWidget = () => {
      if (focusedWidget !== null) {
        const newWidgets = widgets.slice(0);
        const focusedWidgetIndex = widgets.findIndex((widget) => widget.widgetInstanceId === focusedWidget);
        if (focusedWidgetIndex !== -1) {
          newWidgets.splice(focusedWidgetIndex, 1);
          props.setErrorState({
            valid: true
          });
          props.setFocusedWidget(null);
          props.setWidgets(newWidgets);
        }
      }
    };

    const move = (dir = "left" || 'right') => {
      const widgetKey = props?.focusedWidget;
      const length = widgets.length - 1; 
      let element1Index = widgets.findIndex(w => w.widgetInstanceId === widgetKey);
      let element2Index = dir === 'right' ? element1Index - 1 : element1Index + 1;
  
      if (element2Index < 0 && dir === 'right') {
        element2Index = length;
      }
      if (element2Index > length && dir === 'left') {
        element2Index = 0;
      }
      [widgets[element2Index], [widgets[element1Index]]] = [widgets[element1Index], [widgets[element2Index]]];
      props.setWidgets(widgets);
      props.animateToFocusedWidget(`${widgets[element1Index].widgetInstanceId}`)
    };
    let focusedWidgetData: WidgetInstance | undefined;
    if (focusedWidget) {
      focusedWidgetData = widgets.find((widget) => widget.widgetInstanceId.toString() === focusedWidget.toString());
    }
  
    const renderHeaderActions = () => {
      if (!focusedWidgetData) {
        return null;
      }
      return (
        <div className={styles.rowHeader}>
          <div>
          <Button
            disabled={props.focusedWidget === null}
            onClick={() => move('left')}
          >
            <KeyboardArrowLeftSharp />
          </Button>
          <Button
            disabled={props.focusedWidget === null}
            onClick={() => move('right')}
          >
            <KeyboardArrowRightSharp />
          </Button>
          </div>
          <div className={styles.errorButton}>
            <DangerIconButton
              onClick={removeFocusedWidget}
            >
              <DeleteIcon />
            </DangerIconButton>
          </div>
        </div>
      );
    };

    const selectedForm = () => {
        if (!focusedWidgetData) {
            return (
              <CardContent>
              <Typography
                variant="h6"
              >
                Please select a widget to start editing.
              </Typography>
            </CardContent>
            );
          }
          if (focusedWidgetData.widgetKey === WidgetKeys.GENERAL_WIDGET) {
            return (
              <GeneralWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                removeFocusedWidget={removeFocusedWidget}
              />
            );
          }
          if (focusedWidgetData.widgetKey === WidgetKeys.HORIZONTAL_WIDGET) {
            return (
              <HorizontalWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                removeFocusedWidget={removeFocusedWidget}
                handleMultipleChangeData={handleMultipleChange}
              />
            )
          }
          if (focusedWidgetData.widgetKey === WidgetKeys.ICON_WIDGET) {
            return (
              <IconWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                removeFocusedWidget={removeFocusedWidget}
                handleMultipleChangeData={handleMultipleChange}
              />
            )
          }
          if (focusedWidgetData.widgetKey === WidgetKeys.VERTICAL_WIDGET) {
            return (
              <VerticalWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                removeFocusedWidget={removeFocusedWidget}
                handleMultipleChangeData={handleMultipleChange}
              />
            )
          }
          if (focusedWidgetData.widgetKey === WidgetKeys.IMAGE_WIDGET) {
            return (
              <ImageWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                handleMultipleChangeData={handleMultipleChange}
                removeFocusedWidget={removeFocusedWidget}
              />
            )
          }
          if (focusedWidgetData.widgetKey === WidgetKeys.CLUB_OCCUPANCY_WIDGET) {
            return (
              <ClubOccupancyWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                removeFocusedWidget={removeFocusedWidget}
              />
            )
          }
          if(focusedWidgetData.widgetKey === WidgetKeys.THUMBNAIL_WIDGET) {
            return (
              <ThumbnailWidgetCard
                focusedWidget={focusedWidget}
                focusedWidgetData={focusedWidgetData}
                handleChangeData={handleChange}
                removeFocusedWidget={removeFocusedWidget}
              />
            )
          }
    };
    return(<>
    {renderHeaderActions()}
    {selectedForm()}
    </>)
};
const SliderWidgetCard: React.FC<Props> = (props: Props) => {
    
    const [widgetKey, setWidgetKey] = useState(WidgetKeys.GENERAL_WIDGET);

    // const [widgets, setWidgets] = useState<WidgetInstance[]>([]);
  
    const {
      customScreens,
    } = stores.customScreenStore.Stores;
  
    const [focusedWidget, setFocusedWidget] = useState<null | string | number>(null);

    const queryParams = new URLSearchParams(useLocation().search);
    const paramLang = queryParams.get('lang');


    useEffect(() => {
      setWidgetKey(props.focusedWidgetData.params.widgetsType as WidgetKeys);
    }, [props.focusedWidgetData.params.widgetsType]);

    useEffect(() => {
      if(!focusedWidget) { return; }
      animateToFocusedWidget(`${focusedWidget}`);
    }, [focusedWidget]);


    useEffect(() => {
      let intialWidth = '8';
      if(props.focusedWidgetData.params.widgetWidth) {
        intialWidth = props.focusedWidgetData.params.widgetWidth;
      }
      if(isCarouselWidget()) {
        props.handleChangeData('widgetWidth' , '24');
      } else {
        props.handleChangeData('widgetWidth' , `${intialWidth}`);
      }
    },[props.focusedWidgetData.params.isCarousel]);

    const isCarouselWidget = () => {
      return `${props.focusedWidgetData.params.isCarousel}` === 'true';
    };
    const isShowAction = () => {
      return `${props.focusedWidgetData.params.showAction}` === 'true';
    };
    const widgets = () => {
      if(props.focusedWidgetData.params.data) {
        return JSON.parse(props.focusedWidgetData.params.data) as WidgetInstance[];
      } else {
        return [];
      }
    };
    const handleNewWidgets = (widgets: WidgetInstance[]) => {
      props.handleChangeData('data' , JSON.stringify(widgets))
    };


  const notAllowedToChangeCurrentSlide = () => { 
    props.setErrorState({
      valid: false,
      message: `Please fill all required fields before focusing on another widget ex. ${props.errorState?.key}`,
      key: props.errorState?.key || 'General: '
    })
  };

    const onClickAddWidget = () => {
      if(!props.errorState.valid) {
        notAllowedToChangeCurrentSlide();
        return;
      }
      const uuid = uuidv4();
      const newWidget: WidgetInstance = {
          width: 6,
          params: {
            title: '',
          },
          widgetInstanceId: uuid,
          widgetKey,
        };
  
        // TODO add 
      const newWidgets = [
        ...widgets(),
      ];
      newWidgets.unshift(newWidget);
      console.log('berfffffffffffffffffffff')
      props.setErrorState(
        getFormErrorState(
          newWidget.widgetKey,
          newWidget.params
        )
      );
      props.handleChangeData('data' , JSON.stringify(newWidgets))
      setFocusedWidget(uuid);
      animateToFocusedWidget(uuid);
      };
      const sliderWidgets = () => {
        return widgets().map((item , index) => {
           return {
             key: item.widgetInstanceId,
             title: item.params.title.trim() || `widget N.${index}`
           };
        });
      };

      const animateToFocusedWidget = (id: string) => {
        const element = document.getElementById('slideContainer');
        if(element) {
          const containerWidth = element?.getBoundingClientRect().width;
          let widgetWidth = +containerWidth / (24 / +props.focusedWidgetData.params.widgetWidth);
          const widgetNumber = widgets().findIndex(w => w.widgetInstanceId == id);
          if(paramLang === 'ar') {
              widgetWidth *= -1;
          }
          element.scrollTo({
              left: (+widgetWidth * widgetNumber),
              top: 0,
              behavior: 'smooth'
          });
        }
      };

      useEffect(() => {
        console.log('params ' , props.focusedWidgetData.params)
        props.handleMultipleChangeData({
          widgetWidth: props.focusedWidgetData.params.widgetWidth || '8',
          showAction: props.focusedWidgetData.params.showAction || 'false',
          title:  props.focusedWidgetData.params.title || '',
          actionRedirect: props.focusedWidgetData.params.actionRedirect || '',
          actionEntityId: props.focusedWidgetData.params.actionEntityId || '',
          widgetsType: props.focusedWidgetData.params.widgetsType || WidgetKeys.GENERAL_WIDGET,
          isCarousel: props.focusedWidgetData.params.isCarousel || 'false',
          data: props.focusedWidgetData.params.data || '[]'
        })
      }, []);

  return (
      (
      <>
        <CardContent>
            <FormControlLabel
                control={
                <Switch
                    checked={isCarouselWidget()}
                    onChange={(event: any) => props.handleChangeData('isCarousel', event.target.checked)}
                    name="isCarousel"
                    color="primary"
                />
                }
                label="Is Carousel"
            />
            <div className={styles.slider}>
                <Typography id="widget-width" gutterBottom>
                    Widget Width :  {props.focusedWidgetData.params.widgetWidth} of 24 = 
                    {24 / Number(props.focusedWidgetData.params.widgetWidth)} Items
                </Typography>
                <Slider
                    value={+props.focusedWidgetData.params.widgetWidth}
                    aria-labelledby="widget-width"
                    step={2}
                    marks
                    min={8}
                    max={24}
                    valueLabelDisplay="auto"
                    onChange={(event, value) => props.handleChangeData('widgetWidth', `${value}`)}
                    disabled={isCarouselWidget()}
                />
            </div>
            <FormControlLabel
                control={
                <Switch
                    checked={isShowAction()}
                    onChange={(event: any) => props.handleChangeData('showAction', event.target.checked)}
                    name="showAction"
                    color="primary"
                />
                }
                label="Show Action"
            />
            {
              isShowAction() &&
              <>
                <TextField
                  value={props.focusedWidgetData.params.title}
                  onChange={(event) => props.handleChangeData('title', event.target.value)}
                  autoFocus
                  margin="dense"
                  id="widgetTitle"
                  label="Widget Title"
                  fullWidth
              />
              <div>
                <span>Navigation options</span>
                <NavigationOptions 
                  redirect= {props.focusedWidgetData.params.actionRedirect}
                  entityId={props.focusedWidgetData.params.actionEntityId}
                  handleEntityIdChangeData= {(value: string) => props.handleChangeData('actionRedirect', value) }
                  handleRedirectChangeData= {(value: string) => props.handleChangeData('actionEntityId', value) }
                />
              </div>
              </>
            }
            <FormControl variant="outlined" className={styles.formControl}>
                <InputLabel>Widgets type</InputLabel>
                <Select
                  label="Widgets type"
                    value={widgetKey}
                    onChange={(event: any) => props.handleChangeData('widgetsType', event.target.value)}
                    disabled={(!!props.focusedWidgetData.params.widgetsType && !!widgets().length)}

                    >
                    {Object.values(SliderWidgetKeys).map(
                      type => (<MenuItem value={type}>{type}</MenuItem>
                      ))}
               </Select>
               <Button
                className={styles.formControl}
                variant="outlined"
                onClick={onClickAddWidget}
                disabled={!props.focusedWidgetData.params.widgetsType}
               >Add Widget</Button>
            </FormControl>
            
              <FormControl variant="outlined" className={styles.formControl}>
                  <InputLabel>Select Slider Item</InputLabel>
                  <Select
                      label="Select Slider Item"
                      onChange={(event: any) => (setFocusedWidget(event.target.value))}
                      disabled={!props.errorState.valid}
                      className={styles.selectField}
                      value={focusedWidget}
                  >
                      {sliderWidgets().map(item => (<MenuItem value={item.key}>{item.title}</MenuItem>) )}
                </Select>
              </FormControl>
            <GetWidgetForm
                type={props.focusedWidgetData.params.widgetsType as WidgetKeys || undefined} 
                widgets={widgets()}
                focusedWidget={focusedWidget}
                setWidgets={(widgets) => handleNewWidgets(widgets)}
                setFocusedWidget={(id) => setFocusedWidget(id)}
                setErrorState={(state) => props.setErrorState(state)}
                animateToFocusedWidget={animateToFocusedWidget}
             />
        </CardContent>
      </>
      )
    );
};

export default SliderWidgetCard;